import { Router, RouterModule } from '@angular/router';
import { Component } from "@angular/core";
import { CoreService } from "../../services/coreService";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddValletParkingComponent } from '../add-vallet-parking/add-vallet-parking.component';

declare let toastr: any;

@Component({
    selector: 'app-new-vallet-parking',
    templateUrl: './new-vallet-parking.component.html',
    styleUrls: ['./new-vallet-parking.component.scss'],
    providers: [CoreService],
    standalone: true,
     imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AddValletParkingComponent
  ],
})

export class NewValletParkingComponent {
  constructor(private coreService: CoreService, private router: Router) {}

  saveValletParking(form) {
    this.coreService
      .SaveValletParking(form)
      .then(result => {
        // this.iLoader = false;
        // this.router.navigate(['supplier/thankyou']);

        toastr.success("", "Valet Parking added successfully..", {
          timeOut: 2000
        });
        this.router.navigateByUrl('/user/valletparking/' + result.data.id);
      })
      .catch(result => {
        // this.iLoader = false;
        toastr.error("", "error registering you this time..", {
          timeOut: 2000
        });
      });
  }
}
